import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import React from "react";
import { Parser, Tag } from "bbcode-to-react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var parser = new Parser();

// [p]
parser.registerTag("p", /*#__PURE__*/function (_Tag) {
  function _class() {
    _classCallCheck(this, _class);
    return _callSuper(this, _class, arguments);
  }
  _inherits(_class, _Tag);
  return _createClass(_class, [{
    key: "toReact",
    value: function toReact() {
      return /*#__PURE__*/_jsx("p", {
        children: this.getComponents()
      });
    }
  }]);
}(Tag));

// [br]
parser.registerTag("br", /*#__PURE__*/function (_Tag2) {
  function _class2(renderer) {
    var _this;
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, _class2);
    _this = _callSuper(this, _class2, [renderer, settings]);
    self.SELF_CLOSE = true;
    return _this;
  }
  _inherits(_class2, _Tag2);
  return _createClass(_class2, [{
    key: "toReact",
    value: function toReact() {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("br", {}), this.getComponents()]
      });
    }
  }]);
}(Tag));

// [ol]
parser.registerTag("ol", /*#__PURE__*/function (_Tag3) {
  function _class3(renderer) {
    var _this2;
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, _class3);
    _this2 = _callSuper(this, _class3, [renderer, settings]);
    _this2.STRIP_INNER = true;
    _this2.STRIP_OUTER = true;
    return _this2;
  }
  _inherits(_class3, _Tag3);
  return _createClass(_class3, [{
    key: "toReact",
    value: function toReact() {
      return /*#__PURE__*/_jsx("ol", {
        children: this.getComponents()
      });
    }
  }]);
}(Tag));

// [li], [*]
var ListItemTag = /*#__PURE__*/function (_Tag4) {
  function ListItemTag(renderer) {
    var _this3;
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ListItemTag);
    _this3 = _callSuper(this, ListItemTag, [renderer, settings]);
    _this3.CLOSED_BY = ["*", "li", "/list", "/ol"];
    _this3.STRIP_INNER = true;
    return _this3;
  }
  _inherits(ListItemTag, _Tag4);
  return _createClass(ListItemTag, [{
    key: "toReact",
    value: function toReact() {
      return /*#__PURE__*/_jsx("li", {
        children: this.getComponents()
      });
    }
  }]);
}(Tag);
parser.registerTag("*", ListItemTag);
parser.registerTag("li", ListItemTag);
export default parser;
//# sourceMappingURL=bbcode.js.map